'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formConfig, formValues, trackingCode) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  var data = _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: expiry_date
  });

  data.additional_data.trip_cost = additional_data.trip_cost ? additional_data.trip_cost.replace(/\$/g, '').replace(/,/g, '') : additional_data.trip_cost;
  data.additional_data.destination = additional_data.country_of_origin === 'CA' ? additional_data.destination : 'CA';

  return data;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/association/application.js
// module id = 1740
// module chunks = 0